module.exports = __webpack_public_path__ + "img/saco-cafe.e2dbbf94.png";